export default __webpack_public_path__ + "static/media/stationReport.f5193053.png";